import React from 'react';
import type { RenderChildrenProps } from '@atlassian/jira-command-palette';
import {
	CommandPaletteChildCommandBody,
	useRegisterChildCommands,
} from '@atlassian/jira-command-palette-child-command-register';
import { IssueActionsEntry } from './issue-actions-entry';

export const IssueActionsBody = ({
	issueKey,
	issueId,
	...rest
}: RenderChildrenProps & { issueKey: string; issueId: string }) => (
	<>
		<CommandPaletteChildCommandBody {...rest} />
		<IssueActionsEntry
			issueKey={issueKey}
			issueId={issueId}
			trigger="command-palette"
			useRegisterCommands={useRegisterChildCommands}
		/>
	</>
);
